import type { SearchParameters } from '../searchParameters';
import {
  SubscriptionPreviewFamilyEnum,
  type SubscriptionPreview,
} from '../searchProfile';
import { isEditorialOnly, isFilm } from '../searchParameters';

export enum SubscriptionPreviewUnavailableVariantEnum {
  OTHER_IMAGE_FAMILY = 'otherImageFamily',
  VIDEO = 'video',
}

// Which of the previewed subscription's boundaries the current search falls outside of, or
// `null` when everything it asks for is included.
//
// The Video tab's secondary Creative/Editorial controls change `family` while `assettype` stays
// `film`, so isFilm must be checked before isEditorialOnly - otherwise a film+editorial search
// would wrongly resolve to otherImageFamily instead of video.
export const getSubscriptionPreviewUnavailableVariant = (
  searchParameters: SearchParameters,
  subscriptionPreview: SubscriptionPreview | undefined
): SubscriptionPreviewUnavailableVariantEnum | null => {
  if (!subscriptionPreview?.inPreview) return null;

  if (isFilm(searchParameters)) {
    return subscriptionPreview.includesVideo
      ? null
      : SubscriptionPreviewUnavailableVariantEnum.VIDEO;
  }
  if (isEditorialOnly(searchParameters)) {
    return subscriptionPreview.includedFamilies?.includes(
      SubscriptionPreviewFamilyEnum.EDITORIAL
    )
      ? null
      : SubscriptionPreviewUnavailableVariantEnum.OTHER_IMAGE_FAMILY;
  }
  return null;
};

// Editorial plans span both image families, so a previewer can search a term that exists on the
// open SRP but not in the plan. Product asked for the caveat on editorial preview only.
export const shouldShowSubscriptionPreviewZeroResultsNote = (
  subscriptionPreview: SubscriptionPreview | undefined
): boolean =>
  Boolean(
    subscriptionPreview?.inPreview &&
      subscriptionPreview.family === SubscriptionPreviewFamilyEnum.EDITORIAL
  );
